module.exports = __webpack_public_path__ + "img/ic_team_website.30af2a1b.svg";